import React from 'react';
import _ from 'underscore';
import TextWithReferences from '../../PageElements/TextWithReferences/TextWithReferences';
import SlotDropdownSessionItem from './SlotDropdownSessionItem';
import { SlotData } from '@app/common';
import { getVisibleSessionIdsForUser, slotIsFinished } from '../../../../services/DecisionTreeService/DecisionTreeService';
import { useAppSelector } from '../../../../store/hooks';
import checkMarkIcon from '../../../../static/icons/icon_check-mark_green.svg';
import arrowIcon from '../../../../static/icons/arrow.svg';

type SlotProps = {
    slotId: `slot_${string}`;
    slotData: SlotData;
};

const SlotDropdown = (props: SlotProps) => {
    const { slotId, slotData } = props;
    const moduleState = useAppSelector(state => state.moduleState.currentModuleState);
    const config = useAppSelector(state => state.globalState.config);
    const userProperties = useAppSelector(state => state.globalState.user?.userProperties);
    const [expanded, setExpanded] = React.useState<boolean>(false);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    const getClassName = () => {
        let name = 'slot';
        if (expanded) {
            name += ' slot-expanded';
        }
        return name;
    };

    const getDescription = () => {
        if (slotData.desc === '') {
            return '';
        } else {
            return <TextWithReferences text={slotData.desc || ''} />;
        }
    };

    const visibleSessionIds = getVisibleSessionIdsForUser(slotData, moduleState.modifiers, userProperties || []);

    const getSlotStatusLabel = () => {
        let content = <></>;
        if (slotIsFinished(slotId, visibleSessionIds, moduleState.finished, config?.enableTransientSessionModes === true)) {
            content = <img src={checkMarkIcon} />;
        }
        return <span className="slot-status">
            <span className="slot-status-done">
                {content}
            </span>
        </span>;
    };

    const getSlotSessionList = () => {
        return visibleSessionIds.map(sessionId =>
            <SlotDropdownSessionItem
                key={sessionId}
                currSlotId={slotId}
                sessionId={sessionId}
                session={slotData.sessions[sessionId]}
            />);
    };

    return (
        <div className={getClassName()}>
            <div className="slot-header" onClick={toggleExpanded}>
                <div className="slot-info">
                    <h2 className="slot-title">{slotData.caption}</h2>
                    <span className="slot-description">{getDescription()}</span>
                </div>

                {getSlotStatusLabel()}
                <img src={arrowIcon} alt="arrow pointing down" className={'slot-expand-button ' + (expanded ? 'expanded' : '')} />
            </div>
            <div className="slot-session-list">
                {expanded && getSlotSessionList()}
            </div>
        </div>
    );
};
export default SlotDropdown;